import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-167" data-mp="21x25kbat0z3c">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-slate-700 border-l-4 border-l-amber-400 bg-slate-900 p-4 pr-10 text-white shadow-2xl shadow-black/50" aria-live="polite" data-id="element-168" data-mp="21yvddtx5lpcx">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-slate-300 transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400" aria-label="Chiudi avviso" data-id="element-169" data-mp="1sfwfsph3ciad">
            <XIcon className="h-4 w-4" data-id="element-170" data-mp="1jhkhs2dwai7w" />
          </button>
          <div className="flex gap-3" data-id="element-171" data-mp="1nfi858jejacv">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" aria-hidden="true" data-id="element-172" data-mp="1ninzyvjf0qca" />
            <div data-id="element-173" data-mp="19nlirc94bek6">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-amber-400" data-id="element-174" data-mp="1efv8ar6bmclx">Accesso confermato</p>
              <p className="mt-1 text-sm leading-snug text-slate-300" data-id="element-175" data-mp="zs0f79oei68b">
                Una volta completato l&apos;acquisto riceverai la
                <br data-id="element-176" data-mp="14qld32g6kdtl" />
                <span className="font-bold text-white" data-id="element-177" data-mp="qqkczp7qpaf6">GEOLOGIA — Edizione Docenti</span>
              </p>
              <p className="mt-2 text-xs text-slate-300" data-id="element-178" data-mp="vpngv6bzhalk">Accesso digitale immediato via email.</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}